import React, { useState } from 'react';
import Modal_contact_zoho from "./Modal_contact_zoho";

const Contact_form_zoho1 = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
    {isOpen && <Modal_contact_zoho setIsOpen={setIsOpen} />}
    <div className="flex items-center justify-center h-[75vh]">
      <button     
        onClick={() => {
          setIsOpen(true);
        }} 
        className="px-8 py-3.5 bg-blue-600 text-white rounded hover:bg-blue-700">
        Modal Zoho CRM
      </button>
    </div>
    </>
  );
};

export default Contact_form_zoho1;
